// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1wh9H","list":"styles_list__10C-2"};